export default {
  lineNumberColor: `#aaa`,
  lineNumberBgColor: `#222`,
  backgroundColor: `#222`,
  textColor: `#aaa`,
  substringColor: `#aaa`,
  keywordColor: `#6644aa`,
  attributeColor: `#32aaee`,
  selectorAttributeColor: `#6644aa`,
  docTagColor: undefined,
  nameColor: `#6644aa`,
  builtInColor: `#32aaee`,
  literalColor: `#32aaee`,
  bulletColor: `#ffcc33`,
  codeColor: `#aaa`,
  additionColor: `#00cc66`,
  regexpColor: `#ffcc33`,
  symbolColor: `#ffcc33`,
  variableColor: `#bb1166`,
  templateVariableColor: `#32aaee`,
  linkColor: `#32aaee`,
  selectorClassColor: `#6644aa`,
  typeColor: `#32aaee`,
  stringColor: `#ffcc33`,
  selectorIdColor: `#6644aa`,
  quoteColor: `#444`,
  templateTagColor: `#bb1166`,
  deletionColor: `#bb1166`,
  titleColor: `#bb1166`,
  sectionColor: `#fff`,
  commentColor: `#444`,
  metaKeywordColor: `#aaa`,
  metaColor: `#444`,
  functionColor: `#aaa`,
  numberColor: `#00cc66`,
}
